module.exports = __webpack_public_path__ + "static/social-dashboard-blue-8c0f022012d87c75394a328f9cfa8c08.svg";